import { render, staticRenderFns } from "./whatnowDownloadImage.vue?vue&type=template&id=4a4e858f&scoped=true"
import script from "./whatnowDownloadImage.vue?vue&type=script&lang=js"
export * from "./whatnowDownloadImage.vue?vue&type=script&lang=js"
import style0 from "./whatnowDownloadImage.vue?vue&type=style&index=0&id=4a4e858f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4e858f",
  null
  
)

export default component.exports